import "../styles/models.css";

import ric from "../assets/images/ric.png";
import bte from "../assets/images/bte.png";
import cic from "../assets/images/cic.png";
import itc from "../assets/images/itc.png";
import ite from "../assets/images/ite.png";
const models = [
  {
    image: ric,
    title: "Receiver-In-Canal (RIC)",
    description:
      "A discreet hearing aid suitable for mild to severe hearing loss with natural sound quality.",
  },
  {
    image: bte,
    title: "Behind-The-Ear (BTE)",
    description:
      "Powerful and reliable hearing aids designed for all types of hearing loss.",
  },
  {
    image: cic,
    title: "Completely-In-Canal (CIC)",
    description:
      "Virtually invisible hearing aids offering excellent cosmetic appeal and comfort.",
  },
  {
    image: itc,
    title: "In-The-Canal (ITC)",
    description:
      "Comfortable custom hearing aid for everyday hearing needs.",
  },
  {
    image: ite,
    title: "In-The-Ear (ITE)",
    description:
      "Custom-made hearing aid offering excellent comfort and performance.",
  },
];

function Models() {
  return (
    <section className="models">

      <div className="section-title">
        <span><h1>Our Products</h1></span>

        <h3>Hearing Aid Models</h3>

        <p>
          Choose from a wide range of modern hearing aids designed to match
          your lifestyle and hearing needs.
        </p>
      </div>

      <div className="models-container">

        {models.map((item, index) => (
          <div className="model-card" key={index} data-aos="zoom-in" data-aos-duration="900" data-aos-delay={index * 150}>

            <img src={item.image} alt={item.title} />

            <div className="model-content">

              <h3>{item.title}</h3>

              <p>{item.description}</p>

              {/* <button>Learn More</button> */}

            </div>

          </div>
        ))}

      </div>

    </section>
  );
}

export default Models;